import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Il plumcake viene secco e senza sapore', 'Si affossa al centro durante la cottura', 'Non ha il gusto che ti aspettavi', 'La ricetta non viene mai come nelle foto'];
  return <section className="py-16 px-4 bg-white" data-id="element-228">
      <div className="max-w-4xl mx-auto" data-id="element-229">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-230">
          😩 Se hai mai provato a fare plumcake...
        </h2>
        <p className="text-xl text-center text-gray-600 mb-10" data-id="element-231">
          Probabilmente ti è successo questo:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-232">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-4 p-6 bg-red-50 border border-red-100 rounded-2xl" data-id="element-233">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-234" />
              <p className="text-lg text-red-900 font-medium" data-id="element-235">{problem}</p>
            </div>)}
        </div>
      </div>
    </section>;
}